import React, { useState, useEffect,useRef } from "react";
import { Button, Box, VStack, useTheme, useToast,Icon, Text, Flex } from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons"; // You can replace this with an appropriate CSV/Excel icon
import { isDemoSupplier, getDemoUrl } from "../../../tools/demoConfig";

const Exports = ({ supplier, retailer }) => {
  const [showButtons, setShowButtons] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const toast = useToast();
  const containerRef = useRef(null)
  const timeoutRef = useRef(null)
  const fetchCsv = async (vars, url, name) => {
    if (isDemoSupplier(supplier)) url = getDemoUrl(url);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(vars),
    };

    try {
      setIsLoading(true);
      const response = await fetch(url, requestOptions);
      setIsLoading(false);

      const contentType = response.headers.get("content-type");
      console.log("contentType: ", contentType);
      if (contentType && (contentType.includes("text/csv") || contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"))) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${name}_${vars.supplier}_${vars.retailer}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast({
          title: "Success",
          description: `${name} file downloaded successfully.`,
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        console.log("error", response);
        toast({
          title: "Error",
          description: "An error occurred while downloading the file.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setIsLoading(false);
      toast({
        title: "Technical Error",
        description: "A technical error occurred.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleRangingClick = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/rep_ranging/csv-rangingReport`;
      const name = "Ranging Report";
      const vars = { supplier, retailer, userid: 1 };
      await fetchCsv(vars, url, name);
      setShowButtons(false);
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };
   const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    setShowButtons(true)
  }

  const handleMouseLeave = () => {
    // Add a small delay before hiding to allow smooth transition to dropdown
    timeoutRef.current = setTimeout(() => {
      setShowButtons(false)
    }, 150)
  }

  useEffect(() => {
    if (showButtons) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [showButtons]);
    useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return (
    <Box ref={containerRef} position="relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Box bg="white" borderRadius="xl" shadow="lg" border="1px" borderColor="gray.200" p={2}>
        <Button
          leftIcon={<DownloadIcon />}
          bg={theme.colors.primary1}
          _hover={{
            bg: theme.colors.primary2,
            transform: "translateY(-1px)",
            shadow: "md",
          }}
          _active={{
            transform: "translateY(0px)",
            shadow: "sm",
          }}
          color="white"
          variant="solid"
          isLoading={isLoading}
          loadingText="Exporting..."
          borderRadius="lg"
          px={4}
          py={2}
          fontWeight="semibold"
          transition="all 0.2s"
          shadow="sm"
          size="sm"
          minW="120px" // Ensure consistent button width
        >
          Export
        </Button>

        {showButtons && (
          <Box
            position="absolute"
            top="100%"
            left={0}
            mt={0} // Remove gap between button and dropdown
            w="100%"
            minW="180px" // Ensure dropdown is wide enough
            animation="slideIn 0.2s ease-out"
            onMouseEnter={handleMouseEnter} // Keep dropdown open when hovering over it
            onMouseLeave={handleMouseLeave}
          >
            <Box
              bg="white"
              borderRadius="lg"
              shadow="xl"
              border="1px"
              borderColor="gray.200"
              overflow="hidden"
              mt={1} // Small gap for visual separation
            >
              <VStack spacing={0}>
                <Button
                  w="100%"
                  variant="ghost"
                  _hover={{
                    bg: theme.colors.primary1,
                    color: "white",
                  }}
                  onClick={handleRangingClick}
                  borderRadius="lg"
                  py={3}
                  px={4}
                  transition="all 0.2s"
                  justifyContent="flex-start"
                  size="sm"
                  height="auto" // Allow button to expand with content
                  whiteSpace="normal" // Allow text wrapping if needed
                >
                  <Flex align="center" gap={3} w="100%">
                    <Icon as={DownloadIcon} flexShrink={0} />
                    <Text
                      fontWeight="medium"
                      fontSize="sm"
                      textAlign="left"
                      overflow="visible" // Ensure text isn't cut off
                      whiteSpace="nowrap" // Keep on one line but don't cut off
                    >
                      Ranging Report
                    </Text>
                  </Flex>
                </Button>
              </VStack>
            </Box>
          </Box>
        )}
      </Box>

      <style jsx>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-5px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </Box>
  );
};

export default Exports;
